import { Col, Row } from 'antd';
import PropType from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';

export const NotificationExpandable = ({ rowData }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.NOTIFICATION);
  const { message } = rowData;

  return (
    <Row>
      <Col className="notification-expandable-space" />
      <Col>
        <div className="notification-expandable">
          {t(`${message}.consequence`, {
            ns: TRANSLATION_NAMESPACES.NOTIFICATION_CODES
          })}
        </div>
      </Col>
    </Row>
  );
};

NotificationExpandable.propTypes = {
  rowData: PropType.objectOf(
    PropType.oneOfType([PropType.object, PropType.number, PropType.string])
  ).isRequired
};

export default NotificationExpandable;
